<template>
  <div class="materials-item-proftest">
    <img
      src="/img/materials/items/proftest-preview.webp"
      data-lazy-src="/img/materials/items/proftest.webp"
      alt="image"
      loading="lazy"
    >

    <h3>пройдите <span>бесплатный</span> профтест</h3>
    <p>узнайте какая профессия больше подходит именно вам</p>
    <button
      class="m-btn"
      @click="startProftest"
    >
      начать профтест
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import pagesLand from '~/data/pagesLand';

export default {
  name: 'MaterialsItemProftest',
  computed: {
    ...mapGetters({
      categories: 'getMaterialCategories',
    }),
    pagesLandCode() {
      const category = this.categories.find(({ slug }) => (slug === this.$route.params.material_category));
      return category?.landCode || pagesLand[this.$route.name];
    },
  },
  mounted() {
    document.onreadystatechange = () => {
      if (document.readyState === 'complete') {
        const lazyImages = document.querySelectorAll('img[data-lazy-src]');
        lazyImages.forEach((lazyImage) => {
          // eslint-disable-next-line no-param-reassign
          lazyImage.src = lazyImage.dataset.lazySrc;
        });
      }
    };
  },
  methods: {
    async startProftest() {
      await this.$api.sendLead({
        blankRegistration: true,
        landCode: this.pagesLandCode,
      });
      this.$router.push('/proforientacia/test');
    },
  },
};
</script>

<style scoped lang="scss">

.materials-item-proftest {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: calc(var(--scale) * 16) calc(var(--scale) * 20) calc(var(--scale) * 20);
  border-radius: calc(var(--scale) * 40);
  position: relative;
  height: 100%;
  max-height: calc(var(--scale) * 700);
  max-width: calc(var(--scale) * 446);

  @include media-down($size-tablet) {
    max-height: calc(var(--scale) * 574);
    max-width: calc(var(--scale) * 366);
    padding: calc(var(--scale) * 13) calc(var(--scale) * 8);
    border-radius: calc(var(--scale) * 32);
  }

  img {
    position: absolute;
    inset: 0;
    height: 100%;
    object-fit: cover;
  }

  h3 {
    margin-bottom: calc(var(--scale) * 12);
    position: relative;

    font-weight: 500;
    font-size: calc(var(--scale) * 64);
    line-height: 95%;
    letter-spacing: -0.02em;
    color: #FFCEE2;

    @include media-down($size-tablet) {
      margin-bottom: calc(var(--scale) * 10);
      padding-left: calc(var(--scale) * 8);
      font-size: calc(var(--scale) * 52);
      line-height: 90%;
      letter-spacing: -0.06em;
    }

    span {
      color: #FFFFFF;
    }
  }

  p {
    position: relative;

    font-weight: 500;
    font-size: calc(var(--scale) * 26);
    line-height: 120%;
    color: rgba(255, 255, 255, 0.5);

    @include media-down($size-tablet) {
      padding-left: calc(var(--scale) * 8);
      font-size: calc(var(--scale) * 20);
      line-height: 110%;
      letter-spacing: -0.02em;
    }
  }

  button {
    margin-top: auto;
    width: 100%;
    padding-block: calc(var(--scale) * 31) calc(var(--scale) * 34);
    background-color: #8D176C;
    backdrop-filter: blur(calc(var(--scale) * 5));
    border-radius: calc(var(--scale) * 24);
    transition: 200ms;

    font-weight: 500;
    font-size: calc(var(--scale) * 26);
    line-height: 120%;
    color: #FFFFFF;

    @include media-down($size-tablet) {
      padding-block: calc(var(--scale) * 27);
      font-size: calc(var(--scale) * 22);
    }

    @media (hover: hover) {
      &:hover {
        background-color: #F199CE;
      }
    }
  }
}

</style>
